import React from "react";
import { ArrowUpRight } from "lucide-react";
import logo from "./assets/img/logo-light.svg";
import { CONTACT, NAV } from "../data/content";
import { FacebookIcon, LinkedInIcon, WhatsAppIcon } from "./ui";

const SOCIALS = [
  { label: "LinkedIn", href: "https://www.linkedin.com/", icon: LinkedInIcon },
  { label: "Facebook", href: "https://www.facebook.com/", icon: FacebookIcon },
  { label: "WhatsApp", href: CONTACT.whatsapp, icon: WhatsAppIcon },
];

const Footer = () => (
  <footer className="border-t border-white/10 bg-ink-950">
    <div className="container grid gap-12 py-16 md:grid-cols-12">
      <div className="md:col-span-5">
        <img src={logo} alt="Fronix Studio" width="136" height="36" className="h-9 w-auto" />
        <p className="mt-5 max-w-sm leading-relaxed text-ink-400">
          Secure, scalable and smart access control. The company behind KNTO Pass.
        </p>
        <a
          href={CONTACT.kntoUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-white hover:text-brand-400"
        >
          kntopass.com <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>

      <nav className="md:col-span-3" aria-label="Footer">
        <p className="text-sm font-semibold text-white">Explore</p>
        <ul className="mt-4 space-y-3">
          {NAV.map((item) => (
            <li key={item.id}>
              <a href={`#${item.id}`} className="text-sm text-ink-400 transition hover:text-white">
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="md:col-span-4">
        <p className="text-sm font-semibold text-white">Contact</p>
        <ul className="mt-4 space-y-3 text-sm">
          <li>
            <a href={CONTACT.phoneHref} className="text-ink-400 transition hover:text-white">
              {CONTACT.phoneDisplay}
            </a>
          </li>
          <li>
            <a href={`mailto:${CONTACT.email}`} className="text-ink-400 transition hover:text-white">
              {CONTACT.email}
            </a>
          </li>
          <li className="text-ink-400">{CONTACT.location}</li>
        </ul>
        <ul className="mt-6 flex gap-2">
          {SOCIALS.map(({ label, href, icon: Icon }) => (
            <li key={label}>
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-ink-300 transition hover:border-brand-600 hover:bg-brand-600 hover:text-white"
              >
                <Icon className="h-4 w-4" />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="container flex flex-col items-center justify-between gap-2 py-6 text-sm text-ink-500 sm:flex-row">
        <p>© {new Date().getFullYear()} Fronix Studio. All rights reserved.</p>
        <p>Made in Cairo, Egypt</p>
      </div>
    </div>
  </footer>
);

export default Footer;
